import React from "react";
import SocialLogin from "../SocialLogin";
import {Trans, useTranslation} from "react-i18next";
import {Field, reduxForm} from "redux-form";
import InputField from "../../forms/InputField";
import {email, phone, required} from "./Validation";
import PhoneCodeField from "../../forms/PhoneCodeField";
import CheckboxField from "../../forms/CheckboxField";

function RegisterForm({handleSubmit}) {
    const {t} = useTranslation();

    return <form onSubmit={handleSubmit}>
        <SocialLogin />
        <div className="row">
            <div className="column">
                <span className="label">E-mail</span>
                <div className="text-holder">
                    <Field
                        name="email"
                        type="text"
                        component={InputField}
                        validate={[required, email]}
                        className="text"
                        placeholder={t('Enter your e-mail')}
                    />
                </div>
            </div>
            <div className="column">
                <span className="label"><Trans>Phone number</Trans></span>
                <div className="phone-holder">
                    <div className="custom-select">
                        <Field
                            name="phone[code]"
                            component={PhoneCodeField}
                            isSearchable={true}
                            validate={[required]}
                        />
                    </div>
                    <div className="text-holder">
                        <Field
                            name="phone[number]"
                            type="text"
                            component={InputField}
                            validate={[required, phone]}
                            className="text"
                            placeholder={t('Enter your phone')}
                        />
                    </div>
                </div>
            </div>
        </div>

        <Field
            name="privacy"
            component={CheckboxField}
            validate={[required]}
            className="checkbox-holder inner"
        >
            <Trans i18nKey="I have read and agree to <1>Terms and Condition</1>, <3> Refund Policy</3>, <5>Privacy Policy</5> and <7>Cookie Policy</7>">
                I have read and agree to <a href="#">Terms and Condition</a>, <a href="#"> Refund Policy</a>, <a href="#">Privacy Policy</a> and<a href="#">Cookie Policy</a>
            </Trans>
        </Field>
        <Field
            name="subscribe"
            component={CheckboxField}
            className="checkbox-holder inner"
        >
            <Trans>I want to receive news and special offers</Trans>
        </Field>
    </form>
}

RegisterForm = reduxForm({
    form: 'RegisterForm',
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
})(RegisterForm)

export default RegisterForm